import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PaymentReceiptComponent } from '../payment-receipt/payment-receipt.component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-count-fee-report',
  templateUrl: './count-fee-report.component.html',
  styleUrls: ['./count-fee-report.component.scss']
})
export class CountFeeReportComponent implements OnInit {
  FeeReport: FormGroup;
  today: Date = new Date();
  SearchForm: FormGroup;
  courseList: any;
  filteredCourseList: any;
  collegedataList: any[];
  filteredListCollege: any[];
  GridData: any;
  TotalCount: any;
  hideStudentDetailsColumns = false;
  dialogRef: MatDialogRef<any>;
  TodayCollection: any;
  TodayRegisteredStudents: any;
  TotalCollection: any;
  TotalRegisteredStudents: any;
  sessionList: any[];
  SessionFilterList: any[];
  codeTypeList: any;
  filteredCodeType: any;
  feeTypeMap: any = {
    AF: 'Registration Fee',
    EF: 'Exam Fee',
    RC: 'Rank Certificate',
    PC: 'Provisional Passing Certificate',
    OPC: 'Original Passing Certificate',
    MC: 'Migration Certificate',
    ALL: 'Total'
  };
  showSummaryTable = false;
  constructor(
    private dialog: MatDialog,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService,
    public router: Router,
    public fb: FormBuilder
  ) {
    this.APIService = environment.serviceUrl;
  }
  APIService: string;
  regCreate = true;
  regUpdate = true;
  regDelete = true;
  userPermission: any;
  utp: any;
  SessionNo: any;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  Table = false;
  list = true;
  downloadhide = false;
  DefaultSessionNo: any;
  summaryData: any[] = [];
  totalCollectionLabel = 'Total Collections';
  totalRegistrationLabel = 'Total Apply';
  todayCollectionLabel = "Today's Collections";
  todayRegistrationLabel = "Today's Apply";

  ngOnInit(): void {
    this.Table = false;
    this.downloadhide = false;
    this.list = true;
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');

    if (JSON.parse(sessionStorage.getItem("session")) == null) {
      this.fetchSecretData();
    }
    else if (JSON.parse(sessionStorage.getItem("session")) != null) {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      // this.SessionNo = sessionData.SnNo
      // this.DefaultSessionNo = defaultSession.CdCode;
      this.spinner.show();
    }

    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
        if (element.PageName == 'Admission Form' && element.PCreate == false) {
          this.regCreate = false;
        }
        if (element.PageName == 'Admission Form' && element.PUpdate == false) {
          this.regUpdate = false;
        }
        if (element.PageName == 'Admission Form' && element.PDelete == false) {
          this.regDelete = false;
        }
      });
    }

    this.FeeReport = this.fb.group({
      SessionId: new FormControl(''),
      CgCode: new FormControl(''),
      CoCode: new FormControl(''),
      FeeType: new FormControl(''),
      FromDate: new FormControl(null),
      ToDate: new FormControl(null)

    });
    this.SearchForm = this.fb.group({
      SearchString: new FormControl(''),
    });
    //  this.fetchSummaryTable();
    this.getCourseData();
    // this.fetchSession();
    this.fetchCodeType();
    this.fetchDashboardCount();
    this.FeeReport.valueChanges.subscribe((values) => {
      const fromDate = values.FromDate;
      const toDate = values.ToDate;

      if (fromDate && isNaN(new Date(fromDate).getTime())) return;
      if (toDate && isNaN(new Date(toDate).getTime())) return;
  this.validateDates(); 

  if (this.FeeReport.get('ToDate')?.errors || this.FeeReport.get('FromDate')?.errors) {
    return;
  }
      if (this.Table) {

        if (
          (fromDate && toDate) ||
          (!fromDate && !toDate)
        ) {


          this.fetchDashboardSummary();
          this.fetchList();
        }

      }

    });
  }



  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      // this.SessionNo = res.projectPharam['SnNo'];
      // this.DefaultSessionNo = res.projectPharam['SnNo'];
      this.fetchCodeType();
      this.fetchDashboardSummary();
      // this.spinner.show();
    }
    );
  }
  onSessionChange(value: any) {
    this.SessionNo = value;
    this.FeeReport.patchValue({
      FeeType: '',
      CoCode: '',
      CgCode: '',
      FromDate: null,
      ToDate: null
    });
    this.clearData();
    this.setDashboardLabels('ALL');
    this.fetchDashboardSummary();
  }
  getCourseData() {
    this.spinner.show()
    const payload = {};
    this.umsService.fetchCutOffCourse(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.courseList = res.data;
        this.filteredCourseList = this.courseList.slice();
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  fetchDashboardCount() {
    this.TodayCollection = '-';
    this.TodayRegisteredStudents = '-';
    this.TotalCollection = '-';
    this.TotalRegisteredStudents = '-';
  }
  getCollegeData(CoCode) {
    this.Table = false;
    this.TotalCount = 0;
    this.GridData = [];
    this.FeeReport.patchValue({
      CgCode: ''
    });
    this.collegedataList = [];
    this.filteredListCollege = []
    this.spinner.show();
    const payload = {};
    payload['CoCode'] = CoCode;
    payload['CgCode'] = '';
    payload['CoStr'] = '';
    this.umsService.getCollegeCourse(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.collegedataList = Array.from(
          new Map(res.data.map((item) => [item.CgCode, item])).values()
        );

        this.filteredListCollege = [...this.collegedataList];

      }
      else {
        this.spinner.hide();
        this.collegedataList = [];
        this.filteredListCollege = []
      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }
  fetchList() {
    const payload: any = {};
    const feeType = this.FeeReport.value.FeeType;
    payload['CgCode'] = this.FeeReport.value.CgCode || '';
    payload['CoCode'] = this.FeeReport.value.CoCode || '';
    payload['SessionId'] = this.FeeReport.value.SessionId || this.SessionNo || '';
    payload['FeeType'] = this.FeeReport.value.FeeType || '';
    const fromDate = this.FeeReport.value.FromDate;
    const toDate = this.FeeReport.value.ToDate;
    payload['FromDate'] = this.formatDateToSQL(this.FeeReport.value.FromDate);
    payload['ToDate'] = this.formatDateToSQL(this.FeeReport.value.ToDate);
    this.spinner.show();
    this.umsService.FeeCountData(payload).subscribe(res => {
      if (res && res.status) {
        this.spinner.hide();
        this.GridData = res.data || [];
        this.Table = this.GridData.length > 0;
        this.TotalCount = this.GridData.length
        this.downloadhide = true
        // this.fetchDashboardSummary()
      } else {
        this.spinner.hide();
        this.GridData = [];
        this.TotalCount = 0;
        this.TodayCollection = 0
        this.TodayRegisteredStudents = 0
        this.TotalCollection = 0
        this.TotalRegisteredStudents = 0
        this.downloadhide = false
        // this.Table = false;
        // this.list = true;
        const data = { message: res?.message || "No Data Found", title: 'Information', icon: 'fas fa-close' };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.GridData = [];
      this.TotalCount = 0;
      this.TodayCollection = 0
      this.TodayRegisteredStudents = 0
      this.TotalCollection = 0
      this.TotalRegisteredStudents = 0
      // this.Table = false;
      // this.list = true;
      const data = { message: "Server error", title: 'Error', icon: 'fas fa-close' };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  getTodaySQLDate(): string {
    const d = new Date();
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }
  addnewrecord(item) {
    sessionStorage.setItem('TemplateCode', item.FeeTemplateCode);
    let data = {};
    data['SnNo'] = this.SessionNo;
    data['TemplateCode'] = item.FeeTemplateCode;
    data['StuId'] = item.StuId;
    data['FeeType'] = item.FeeType;
    data['Fee'] = item.FeeType === 'AF' ? 'Registration Fee Receipt' : 'Exam Fee Receipt';
    const dialogRef = this.dialog.open(PaymentReceiptComponent, {
      width: 'auto',
      data,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }


  //   download(){
  //     if (!this.GridData || this.GridData.length === 0) {
  //       console.warn('No data available to download');
  //       return;
  //     }
  //     const feeType = this.FeeReport.value.FeeType;
  //     const hideCols = ['RC', 'PC', 'OPC', 'MC'].includes(feeType);

  //     // Define CSV headers
  //     const headers = hideCols
  //   ? ['Sr No','Student Name','Father Name','Mother Name','Mobile Number','Email Id','Fee Type','Amount (Rs.)','Payment Mode','Txn Id','Receipt Number','Fee Payment Date']
  //   : ['Sr No','Student Name','Father Name','Mother Name','Course','Whether Student Migrated From','College','Academic Session','Mobile Number','Gender','Email Id','Dob','Fee Type','Amount (Rs.)','Payment Mode','Txn Id','Receipt Number','Fee Payment Date'];

  //     // Process each row and format subjects correctly
  //     const csvRows = this.GridData.map(item => {
  //       // Convert subjects into multiple lines within the same cell
  //       const formattedSubjects = this.formatSubjects(item.StuSubjectName)
  //         .map(subject => `${subject.SubCode} - ${subject.Sub}`) // Format each subject
  //         .join('\n'); // Separate subjects by a new line
  //   if (['RC', 'PC', 'OPC', 'MC'].includes(this.FeeReport.value.FeeType)) {
  //   return [
  //     item.SrNo,
  //     item.FullName,
  //     item.MiddleName,
  //     item.MotherName,
  //     item.StuMobNumber,
  //     item.StuEmailId,
  //     this.feeTypeMap[item.FeeType],
  //     item.AmountPaid,
  //     item.mode,
  //     item.TransactionNo,
  //     item.ReceiptNo,
  //     this.formatDate(item.FeePaymentDate)
  //   ]; }

  //       return [
  //         item.SrNo,
  //         item.FullName,
  //         item.MiddleName,
  //         item.MotherName,
  //         item.CoName,
  //         item.StudentType,
  //         item.CgName,
  //         item.SnNo,
  //         item.StuMobNumber,
  //         item.Gender,
  //         item.StuEmailId,
  //         item.StuBirthDate,
  //         this.feeTypeMap[item.FeeType],
  //         item.AmountPaid,
  //         item.mode,
  //         item.TransactionNo,
  //         item.ReceiptNo,
  //         this.formatDate(item.FeePaymentDate)
  //       ].map(value => `"${value}"`).join(','); // Ensure CSV formatting
  //     });

  //     // Combine headers and rows
  //     const csvString = [headers.join(','), ...csvRows].join('\r\n');

  //     // Create a Blob (CSV file)
  //     const blob = new Blob([csvString], { type: 'text/csv' });
  //     const url = window.URL.createObjectURL(blob);

  //     // Create a link and trigger download
  //     const a = document.createElement('a');
  //     a.href = url;
  //     let fileName = 'PaidFeesCountReport';

  // switch (this.FeeReport.value.FeeType) {
  //   case 'AF':
  //     fileName = 'PaidRegistrationReport';
  //     break;

  //   case 'EF':
  //     fileName = 'PaidExamFeeReport';
  //     break;

  //   case 'RC':
  //     fileName = 'PaidRankCertificateReport';
  //     break;

  //   case 'PC':
  //     fileName = 'PaidProvisionalCertificateReport';
  //     break;

  //   case 'OPC':
  //     fileName = 'PaidOriginalCertificateReport';
  //     break;

  //   case 'MC':
  //     fileName = 'PaidMigrationCertificateReport';
  //     break;

  //   default:
  //     fileName = 'PaidFeesCountReport';
  // }

  // a.download = fileName + '.csv';
  //     // a.download = 'PaidFeesCountReport.csv';
  //     a.click();
  //     window.URL.revokeObjectURL(url);
  //   }
  download() {

    if (!this.GridData || this.GridData.length === 0) {
      console.warn('No data available');
      return;
    }

    const payload: any = {
      SessionId: this.FeeReport.value.SessionId || this.SessionNo || '',
      // FeeType: 'ALL',
      FeeType: this.FeeReport.value.FeeType,
      FromDate: this.formatDateToSQL(this.FeeReport.value.FromDate),
      ToDate: this.formatDateToSQL(this.FeeReport.value.ToDate)
    };

    this.spinner.show();

    this.umsService.FetchSummaryData(payload).subscribe(res => {

      this.spinner.hide();

      const summaryDataExcel = (res.data[0] || []).map(item => ({
        'Fee Type': this.feeTypeMap[item.FeeType] || item.FeeType,
        'Total Student': item.TotalRegisteredStudents,
        'Total Amount': item.TotalCollection
      }));

      const detailedData = this.GridData.map(item => {
        if (['RC', 'PC', 'OPC', 'MC'].includes(this.FeeReport.value.FeeType)) {
          return {
            'Sr No': item.SrNo,
            'Student Name': item.FullName,
            'Father Name': item.MiddleName,
            'Mother Name': item.MotherName,
            'Mobile Number': item.StuMobNumber,
            'Email Id': item.StuEmailId,
            'Fee Type': this.feeTypeMap[item.FeeType],
            'Amount (Rs.)': item.AmountPaid,
            'Payment Mode': item.mode,
            'Txn Id': item.TransactionNo,
            'Receipt Number': item.ReceiptNo,
            'Fee Payment Date': this.formatDate(item.FeePaymentDate)
          };
        }

        return {
          'Sr No': item.SrNo,
          'Student Name': item.FullName,
          'Father Name': item.MiddleName,
          'Mother Name': item.MotherName,
          'Course': item.CoName,
          'Whether Student Migrated From': item.StudentType,
          'College': item.CgName,
          'Academic Session': item.AcademicYear,
          'Mobile Number': item.StuMobNumber,
          'Gender': item.Gender,
          'Email Id': item.StuEmailId,
          'Dob': item.StuBirthDate,
          'Fee Type': this.feeTypeMap[item.FeeType],
          'Amount (Rs.)': item.AmountPaid,
          'Payment Mode': item.mode,
          'Txn Id': item.TransactionNo,
          'Receipt Number': item.ReceiptNo,
          'Fee Payment Date': this.formatDate(item.FeePaymentDate)
        };
      });

      const worksheet1 = XLSX.utils.json_to_sheet(detailedData);
      const worksheet2 = XLSX.utils.json_to_sheet(summaryDataExcel);

      let detailedSheetName = 'Detailed Report';

      switch (this.FeeReport.value.FeeType) {
        case 'AF': detailedSheetName = 'Registration Report'; break;
        case 'EF': detailedSheetName = 'Exam Fee Report'; break;
        case 'RC': detailedSheetName = 'Rank Certificate Report'; break;
        case 'PC': detailedSheetName = 'Provisional Certificate Report'; break;
        case 'OPC': detailedSheetName = 'Original Certificate Report'; break;
        case 'MC': detailedSheetName = 'Migration Certificate Report'; break;
      }

      const workbook: XLSX.WorkBook = {
        Sheets: {
          [detailedSheetName]: worksheet1,
          'Summary Report': worksheet2
        },
        SheetNames: [detailedSheetName, 'Summary Report']
      };

      const excelBuffer: any = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });

      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      let fileName = 'PaidFeesCountReport';

      switch (this.FeeReport.value.FeeType) {
        case 'AF': fileName = 'PaidRegistrationReport'; break;
        case 'EF': fileName = 'PaidExamFeeReport'; break;
        case 'RC': fileName = 'PaidRankCertificateReport'; break;
        case 'PC': fileName = 'PaidProvisionalCertificateReport'; break;
        case 'OPC': fileName = 'PaidOriginalCertificateReport'; break;
        case 'MC': fileName = 'PaidMigrationCertificateReport'; break;
      }

      FileSaver.saveAs(blob, fileName + '.xlsx');

    }, (err) => {
      this.spinner.hide();
      console.error(err);
    });
  }
  // download() {

  //   if (!this.GridData || this.GridData.length === 0) {
  //     console.warn('No data available');
  //     return;
  //   }
  //   const detailedData = this.GridData.map(item => {

  //     if (['RC', 'PC', 'OPC', 'MC'].includes(this.FeeReport.value.FeeType)) {
  //       return {
  //         'Sr No': item.SrNo,
  //         'Student Name': item.FullName,
  //         'Father Name': item.MiddleName,
  //         'Mother Name': item.MotherName,
  //         'Mobile Number': item.StuMobNumber,
  //         'Email Id': item.StuEmailId,
  //         'Fee Type': this.feeTypeMap[item.FeeType],
  //         'Amount (Rs.)': item.AmountPaid,
  //         'Payment Mode': item.mode,
  //         'Txn Id': item.TransactionNo,
  //         'Receipt Number': item.ReceiptNo,
  //         'Fee Payment Date': this.formatDate(item.FeePaymentDate)
  //       };
  //     }

  //     return {
  //       'Sr No': item.SrNo,
  //       'Student Name': item.FullName,
  //       'Father Name': item.MiddleName,
  //       'Mother Name': item.MotherName,
  //       'Course': item.CoName,
  //       'College': item.CgName,
  //       'Academic Session': item.AcademicYear,
  //       'Mobile Number': item.StuMobNumber,
  //       'Gender': item.Gender,
  //       'Email Id': item.StuEmailId,
  //       'Dob': item.StuBirthDate,
  //       'Fee Type': this.feeTypeMap[item.FeeType],
  //       'Amount (Rs.)': item.AmountPaid,
  //       'Payment Mode': item.mode,
  //       'Txn Id': item.TransactionNo,
  //       'Receipt Number': item.ReceiptNo,
  //       'Fee Payment Date': this.formatDate(item.FeePaymentDate)
  //     };
  //   });

  //   const worksheet1 = XLSX.utils.json_to_sheet(detailedData);

  //   const summaryDataExcel = this.summaryData.map(item => ({
  //     'Fee Type': this.feeTypeMap[item.FeeType] || item.FeeType,
  //     'Total Student': item.TotalRegisteredStudents,
  //     'Total Amount': item.TotalCollection
  //   }));

  //   let detailedSheetName = 'Detailed Report';

  // switch (this.FeeReport.value.FeeType) {
  //   case 'AF': detailedSheetName = 'Registration Report'; break;
  //   case 'EF': detailedSheetName = 'Exam Fee Report'; break;
  //   case 'RC': detailedSheetName = 'Rank Certificate Report'; break;
  //   case 'PC': detailedSheetName = 'Provisional Certificate Report'; break;
  //   case 'OPC': detailedSheetName = 'Original Certificate Report'; break;
  //   case 'MC': detailedSheetName = 'Migration Certificate Report'; break;
  //   default: detailedSheetName = 'Detailed Report';
  // }
  //   const worksheet2 = XLSX.utils.json_to_sheet(summaryDataExcel);
  //   const workbook: XLSX.WorkBook = {
  //     Sheets: {
  //       // 'Detailed Report': worksheet1,
  //       [detailedSheetName]: worksheet1,
  //       'Summary Report': worksheet2
  //     },
  //     SheetNames: [detailedSheetName, 'Summary Report']
  //   };

  //   const excelBuffer: any = XLSX.write(workbook, {
  //     bookType: 'xlsx',
  //     type: 'array'
  //   });

  //   const blob = new Blob([excelBuffer], {
  //     type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  //   });

  //   let fileName = 'PaidFeesCountReport';

  //   switch (this.FeeReport.value.FeeType) {
  //     case 'AF': fileName = 'PaidRegistrationReport'; break;
  //     case 'EF': fileName = 'PaidExamFeeReport'; break;
  //     case 'RC': fileName = 'PaidRankCertificateReport'; break;
  //     case 'PC': fileName = 'PaidProvisionalCertificateReport'; break;
  //     case 'OPC': fileName = 'PaidOriginalCertificateReport'; break;
  //     case 'MC': fileName = 'PaidMigrationCertificateReport'; break;
  //   }

  //   FileSaver.saveAs(blob, fileName + '.xlsx');
  // }
  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().split('T')[0]; // Returns YYYY-MM-DD format
  }


  keypress() {
    let payload = {}
    payload['SearchString'] = this.SearchForm.value['SearchString'];
    payload['PageSize'] = this.pageSize;
    // payload['PageNumber'] = this.currentPage;
    if (payload['SearchString'] === "") {
      payload['PageNumber'] = this.currentPage;
    } else {
      payload['PageNumber'] = 1;
    }
    this.umsService.FeeCountData(payload).subscribe(res => {
      if (res.status) {
      }
      else {
      }

    }, (ERROR: HttpErrorResponse) => {
    });


  }

  back() {
    this.Table = false;
    this.showSummaryTable = false;
    this.list = true;
    this.TotalCount = 0;
    this.GridData = [];
    // this.FeeReport.reset(); 
    this.FeeReport.reset({}, { emitEvent: false });
    this.SessionNo = this.DefaultSessionNo;
    this.FeeReport.patchValue({
      SessionId: String(this.SessionNo)
    });
    this.setDashboardLabels('ALL');
    this.fetchDashboardSummary();
  }

  formatSubjects(subjectString: string) {
    if (!subjectString) return [];

    return subjectString.split(',').map(sub => {
      const parts = sub.split(';'); // Split each subject by `;`
      return {
        SubCode: parts[0]?.trim() || '',  // First part (SubCode)
        Sub: parts[1]?.trim() || ''       // Second part (Subject Name)
      };
    });
  }

  clearData() {
    this.Table = false;
    this.TotalCount = 0;
    this.GridData = [];
  }

  private formatDateToSQL(date: Date | string | null): string | null {
    if (!date) return null;
    const d = new Date(date);
    if (isNaN(d.getTime())) return null;
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }
  onFeeTypeChange(value: string) {
    this.clearData();
    const disableFeeTypes = ['RC', 'PC', 'OPC', 'MC', 'ALL'];
    if (disableFeeTypes.includes(value)) {
      this.FeeReport.get('CoCode')?.reset();
      this.FeeReport.get('CgCode')?.reset();
      this.FeeReport.get('CoCode')?.disable();
      this.FeeReport.get('CgCode')?.disable();
      this.hideStudentDetailsColumns = true;
    } else {
      this.FeeReport.get('CoCode')?.enable();
      this.FeeReport.get('CgCode')?.enable();
      this.hideStudentDetailsColumns = false;
    }

    this.setDashboardLabels(value);
    // this.fetchDashboardSummary();
  }

  setDashboardLabels(feeType: string) {

    switch (feeType) {

      case 'ALL':
        this.totalRegistrationLabel = 'Total Apply';
        this.todayRegistrationLabel = "Today's Apply";
        this.totalCollectionLabel = 'Total Collection';
        this.todayCollectionLabel = "Today's Collection";
        break;

      case 'AF':
        this.totalRegistrationLabel = 'Total Apply - Registration';
        this.todayRegistrationLabel = "Today's Apply - Registrations";
        this.totalCollectionLabel = 'Total Collection - Registration';
        this.todayCollectionLabel = "Today's Collection - Registration";
        break;

      case 'EF':
        this.totalRegistrationLabel = 'Total Apply - Exam Forms';
        this.todayRegistrationLabel = "Today's Apply - Exam Forms";
        this.totalCollectionLabel = 'Total Collection - Exam Fee';
        this.todayCollectionLabel = "Today's Collection - Exam Fee";
        break;

      case 'RC':
        this.totalRegistrationLabel = 'Total Apply - Rank Certificates';
        this.todayRegistrationLabel = "Today's Apply - Rank Certificates";
        this.totalCollectionLabel = 'Total Collection - Rank Certificate';
        this.todayCollectionLabel = "Today's Collection - Rank Certificate";
        break;

      case 'PC':
        this.totalRegistrationLabel = 'Total Apply - Provisional Passing Certificates';
        this.todayRegistrationLabel = "Today's Apply - Provisional Passing Certificates";
        this.totalCollectionLabel = 'Total Collection - Provisional Passing Certificate';
        this.todayCollectionLabel = "Today's Collection - Provisional Passing Certificate";
        break;

      case 'OPC':
        this.totalRegistrationLabel = 'Total Apply - Original Passing Certificates';
        this.todayRegistrationLabel = "Today's Apply - Original Passing Certificates";
        this.totalCollectionLabel = 'Total Collection - Original Passing Certificate';
        this.todayCollectionLabel = "Today's Collection - Original Passing Certificate";
        break;

      case 'MC':
        this.totalRegistrationLabel = 'Total Apply - Migration Certificates';
        this.todayRegistrationLabel = "Today's Apply - Migration Certificates";
        this.totalCollectionLabel = 'Total Collection - Migration Certificate';
        this.todayCollectionLabel = "Today's Collection - Migration Certificate";
        break;

      default:
        this.totalRegistrationLabel = 'Total Apply';
        this.todayRegistrationLabel = "Today's Apply";
        this.totalCollectionLabel = 'Total Collection';
        this.todayCollectionLabel = "Today's Collection";
    }

  }
  fetchDashboardSummary() {
    const payload: any = {};
    const feeType = this.FeeReport.value.FeeType;
    payload['CgCode'] = this.FeeReport.value.CgCode || '';
    payload['CoCode'] = this.FeeReport.value.CoCode || '';
    payload['SessionId'] = this.FeeReport.value.SessionId || this.SessionNo || '';
    payload['FeeType'] = this.FeeReport.value.FeeType || '';

    payload['FromDate'] = this.formatDateToSQL(this.FeeReport.value.FromDate);
    payload['ToDate'] = this.formatDateToSQL(this.FeeReport.value.ToDate);
    // this.spinner.show();
    this.fetchDashboardCount();
    this.umsService.FeeeCountDashboardSummary(payload).subscribe(res => {
      // this.spinner.hide();
      if (res && res.status) {
        this.TodayCollection = res.data.TodayCollection;
        this.TodayRegisteredStudents = res.data.TodayRegisteredStudents;
        this.TotalCollection = res.data.TotalCollection;
        this.TotalRegisteredStudents = res.data.TotalRegisteredStudents
        this.downloadhide = false
      } else {
        this.TodayCollection = 0
        this.TodayRegisteredStudents = 0
        this.TotalCollection = 0
        this.TotalRegisteredStudents = 0
        this.GridData = [];
        this.TotalCount = 0;
        this.downloadhide = false
        const data = { message: res?.message || "No Data Found", title: 'Information', icon: 'fas fa-close' };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      // this.spinner.hide();
      this.GridData = [];
      this.TotalCount = 0;
      this.TodayCollection = 0
      this.TodayRegisteredStudents = 0
      this.TotalCollection = 0
      this.TotalRegisteredStudents = 0
        this.downloadhide = false
      const data = { message: "Server error", title: 'Error', icon: 'fas fa-close' };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
  fetchSession() {
    const payload = {};
    payload['SnDefault'] = '';
    payload['SnNo'] = '';
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    })
  }
  validateDates() {

    const fromDate = this.FeeReport.get('FromDate')?.value;
    const toDate = this.FeeReport.get('ToDate')?.value;

    const fromDateControl = this.FeeReport.get('FromDate');
    const toDateControl = this.FeeReport.get('ToDate');

    const today = new Date();

    // From Date cannot be greater than today
    if (fromDate && new Date(fromDate) > today) {
      fromDateControl?.setErrors({ ...fromDateControl.errors, maxDate: true });
      return;
    }

    // To Date cannot be greater than today
    if (toDate && new Date(toDate) > today) {
      toDateControl?.setErrors({ ...toDateControl.errors, maxDate: true });
      return;
    }

    // To Date without From Date
    if (toDate && !fromDate) {
      toDateControl?.setErrors({ ...toDateControl.errors, fromRequired: true });
      return;
    }

    // To Date earlier than From Date
    if (fromDate && toDate) {
      if (new Date(toDate) < new Date(fromDate)) {
        toDateControl?.setErrors({ ...toDateControl.errors, invalidDate: true });
        return;
      } else {
        toDateControl?.setErrors(null);
      }
    }

    // this.fetchDashboardSummary();
  }

  fetchCodeType() {
    const payload = {};
    payload['CdType'] = 'Aca';
    this.umsService.getCode(payload).subscribe(res => {
      if (res.status) {
        this.codeTypeList = res.data;
        this.filteredCodeType = this.codeTypeList.slice();
        // if (this.SessionNo) {
        //   this.FeeReport.patchValue({
        //     SessionId: String(this.SessionNo)
        //   });
        // }
          const defaultSession = this.codeTypeList.find(
        x => x.CdDesc === '2026-2027'
      );

      if (defaultSession) {

        this.FeeReport.patchValue({
          SessionId: defaultSession.CdCode
        });

        this.SessionNo = defaultSession.CdCode;
        this.DefaultSessionNo = defaultSession.CdCode;
         this.fetchDashboardSummary();
      }
      } else {
      }
    })
  }


  fetchSummaryTable() {
    const payload: any = {};
    const feeType = this.FeeReport.value.FeeType;
    payload['SessionId'] = this.FeeReport.value.SessionId || this.SessionNo || '';
    payload['FeeType'] = 'ALL';
    payload['FromDate'] = this.formatDateToSQL(this.FeeReport.value.FromDate);
    payload['ToDate'] = this.formatDateToSQL(this.FeeReport.value.ToDate);

    this.umsService.FetchSummaryData(payload).subscribe(res => {
      this.summaryData = res.data[0] || [];
      this.showSummaryTable = true;
      this.Table = false;
      this.list = true;
    });
  }

  viewDetails(FeeType: string) {
    this.showSummaryTable = false;
    this.Table = true;
    this.list = false;
    this.FeeReport.patchValue({
      FeeType: FeeType,
      CoCode: '',
      CgCode: '',
      FromDate: null,
      ToDate: null
    });
    this.onFeeTypeChange(FeeType)
    // this.fetchList(); 
  }

  goBackToSummary() {
    this.Table = false;
    this.list = true;
    this.showSummaryTable = true;
    this.GridData = [];
    this.TotalCount = 0;
    this.FeeReport.patchValue({
      FeeType: '',
      FromDate: null,
      ToDate: null,
      CoCode: '',
      CgCode: ''
    });
    this.setDashboardLabels('ALL');
    this.fetchDashboardSummary();
  }

  getCourseDataChange(CoCode: any) {
    this.FeeReport.patchValue({
      CgCode: ''
    });
    this.getCollegeData(CoCode);
  }


}
